import React, {
  FunctionComponent, useState, useEffect
} from 'react';
import { TagInput, Button } from '@blueprintjs/core';

type Props = {
  placeholder?: string;
  disabled?: boolean;
  value: any;
  onChange?: (name: any, item: any) => void;
  name: string;
};

export const TagInputCustom: FunctionComponent<Props> = ({
  placeholder,
  disabled,
  value,
  name,
  onChange = () => null,
}: Props) => {
  const [values, setValues] = useState([]);

  const handleChange = (newValues: any) => {
    setValues(newValues);
    onChange(name, newValues);
  }

  const handleClear = () => { handleChange([]); }

  useEffect(() => {
    if (value) {
      setValues(value);
    }
  }, [value]);

  const clearButton = (
    <Button
      icon={value.length > 0 ? 'cross' : undefined}
      minimal
      onClick={handleClear}
    />
  );

  return (
    <TagInput
      onChange={handleChange}
      placeholder={placeholder ?? ''}
      rightElement={disabled ? undefined : clearButton}
      values={values}
      disabled={disabled ?? false}
      addOnBlur
    />
  );
};

export default TagInputCustom;
